<template>
  <div class="file-list-download">
    <span
      @click="$downloadFile(getAttachUrl(item))"
      class="download"
      v-for="(item, index) in fileList"
      :key="index"
      v-html="item.attachName"
    >
    </span>
  </div>
</template>

<script>

export default {
  props: {
    // 文件id
    attachIds: String,
    // 文件
    bizData: {
      type: Array,
      default() {
        return [];
      },
    },
    bizId: String,
    bizType: String
  },
  data() {
    return {
      fileList: [],
    };
  },
  watch: {
    attachIds: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getFileList();
        }
      }
    },
    bizId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getFileList();
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    getFileList() {
      if (this.attachIds) {
        const attachIds = this.attachIds;
        this.$getAttachFileList(attachIds).then((list) => {
          this.fileList = list;
        });
      } else if (this.bizId && this.bizType) {
        this.$getFileList({
          bizId: this.bizId,
          bizType: this.bizType
        }).then((list) => {
          this.fileList = list;
        });
      } else {
        this.fileList = this.bizData;
      }

    }
  }
};
</script>

<style></style>
